import { render } from "./PricesModal.vue?vue&type=template&id=9f626026&scoped=true"
import script from "./PricesModal.vue?vue&type=script&lang=js"
export * from "./PricesModal.vue?vue&type=script&lang=js"

import "./PricesModal.vue?vue&type=style&index=0&id=9f626026&lang=css"
import "./PricesModal.vue?vue&type=style&index=1&id=9f626026&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f626026"]])

export default __exports__